<template>
    <div :style="getStyle">
        <label class="btn btn-sm btn-info" v-popover:tooltip="t(getTitle)">
            {{ t(getName) }}
            <input
                type="file" id="file" style="display: none;" ref="file" @change="onClickUploadFile"/>
        </label>
    </div>
</template>

<script>

export default
{
    components: {},
    props: {
        config: {
            type: Object,
            default: function() {
                return {
                    name: null,
                    backgroundColor: null,
                    title: null,
                    active: true,
                    emitEvents: [],
                    uploadFile: false,
                }
            }
        },
        parentState: {
            type: Object,
        },
        eventManager: {
            type: Object,
        },
        row: {
            type: Object,
        },
        rowIndex: {
            type: Number
        },
        columnIndex: {
            type: Number,
        },
    },
    data() {
        return {
            active: true,
            name: null,
            title: null,
            backgroundColor: null,
        };
    },
    computed: {
        getStyle() {
            return this.config.style || {margin: "1px", float: "left"};
        },
        getActive() {
            return this.active;
        },
        getBackgroundColor() {
            return this.backgroundColor;
        },
        getName() {
            return this.name;
        },
        getTitle() {
            return this.title || this.config.title;
        },
    },
    mounted() {
        this.init();
        this.mountEvents();
    },
    beforeDestroy() {
        this.eventManager.unbindEvents(this.defaultBindEvents());
    },
    methods: {
        init() {
            this.componentIndex = this.config.index;
            this.title = this.config.title;
            this.name = this.config.name;
            this.backgroundColor = this.config.backgroundColor;
            this.active = this.config.active;
            this.internalRow = {};
        },
        defaultBindEvents() {
            return [{
                name: 'showComponent',
                componentIndex: this.componentIndex,
            },{
                name: 'hideComponent',
                componentIndex: this.componentIndex,
            }];
        },
        hideComponent() {
            this.active = false;
        },
        setActive(active) {
            this.active = active;
        },
        mountEvents() {
            this.eventManager.bindEvents(this.defaultBindEvents(), this);
        },
        onClickUploadFile() {
            let file = this.$refs.file.files[0];
            let formData = new FormData();
            formData.append('file', file);
            let internalRow = formData;
            this.$refs.file.value = null;
            this.eventManager.emitEvents(this.config.emitEvents['click'], [{state: this.parentState.value, formData: internalRow, row: this.row}]);
        },
        showComponent() {
            this.active = true;
        },
    },
}
</script>

<style lang="sass" scoped>
    .mark-disabled {
        opacity: 0.4!important;
    }
    .action-button-component:hover {
        opacity: 0.7!important;
    }
</style>


// WEBPACK FOOTER //
// UploadButtonComponent.vue?27150f32